import { render, staticRenderFns } from "./answer_mode.vue?vue&type=template&id=9fdbbb7a&scoped=true"
import script from "./answer_mode.vue?vue&type=script&lang=js"
export * from "./answer_mode.vue?vue&type=script&lang=js"
import style0 from "./answer_mode.vue?vue&type=style&index=0&id=9fdbbb7a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fdbbb7a",
  null
  
)

export default component.exports